export class TextService {
  /**
   * Делает первую букву текста заглавной
   * @param text - Текст для капитализации
   * @returns Текст с заглавной первой буквой
   */
  public static capitalize(text: string) {
    return text[0].toUpperCase() + text.slice(1);
  }
}
